(function () {
  var FREE_SHIP_CENTS = 4000;

  function safe(fn, fallback) {
    return function () {
      try {
        var result = fn.apply(null, arguments);
        return result === undefined ? fallback : result;
      } catch (error) {
        return fallback;
      }
    };
  }

  function toCents(value) {
    if (typeof value === 'number' && isFinite(value)) return value;
    if (typeof value === 'string') {
      var parsed = parseFloat(value.replace(/[^0-9.]/g, ''));
      if (isFinite(parsed)) return Math.round(parsed * 100);
    }
    return null;
  }

  function readCart() {
    var rebuy = window.Rebuy;
    if (!rebuy) return null;
    if (rebuy.SmartCart && rebuy.SmartCart.cart && typeof rebuy.SmartCart.cart.item_count === 'number') {
      return rebuy.SmartCart.cart;
    }
    if (rebuy.Cart && rebuy.Cart.cart && typeof rebuy.Cart.cart.item_count === 'number') {
      return rebuy.Cart.cart;
    }
    return null;
  }

  var TRADEUP_PRODUCT_HANDLE = 'starter-kit';
  var PILLS_PER_MONTH = 30;
  var tradeupProduct = null;
  var tradeupProductRequest = null;
  var tradeupCache = { signature: null, offers: [] };

  function routeRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function rerenderSmartCart() {
    var root = document.getElementById('rebuy-cart');
    var vm = root && root.__vue__;
    if (vm && typeof vm.$forceUpdate === 'function') vm.$forceUpdate();
  }

  function loadTradeupProduct() {
    if (tradeupProduct || tradeupProductRequest) return;
    tradeupProductRequest = fetch(routeRoot() + 'products/' + TRADEUP_PRODUCT_HANDLE + '.js')
      .then(function (response) { return response.json(); })
      .then(function (product) {
        tradeupProduct = product;
        tradeupCache.signature = null;
        rerenderSmartCart();
      })
      .catch(function () { tradeupProductRequest = null; });
  }

  function planMonths(plan) {
    if (!plan) return null;
    var text = (plan.name || '') + ' ' + (plan.options || []).map(function (option) { return option.value || ''; }).join(' ');
    var match = text.match(/(\d+)\s*month/i);
    if (match) return parseInt(match[1], 10);
    return /monthly/i.test(text) ? 1 : null;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function buildLadder(product) {
    var plansById = {};
    (product.selling_plan_groups || []).forEach(function (group) {
      (group.selling_plans || []).forEach(function (plan) { plansById[plan.id] = plan; });
    });
    return product.variants
      .filter(function (variant) { return variant.available !== false && window.dpCart.pillCount(variant.title); })
      .map(function (variant) {
        var pills = window.dpCart.pillCount(variant.title);
        return {
          id: variant.id,
          title: variant.title,
          pills: pills,
          months: pills / PILLS_PER_MONTH,
          price: variant.price,
          image: variant.featured_image ? variant.featured_image.src : (product.featured_image || null),
          plans: (variant.selling_plan_allocations || []).map(function (allocation) {
            return { id: allocation.selling_plan_id, price: allocation.price, months: planMonths(plansById[allocation.selling_plan_id]) };
          })
        };
      })
      .sort(function (a, b) { return a.pills - b.pills; });
  }

  function planForMonths(tier, months) {
    return tier.plans.filter(function (plan) { return plan.months === months; })[0] || null;
  }

  function naturalPlan(tier) {
    return planForMonths(tier, tier.months);
  }

  function largestLadderLine(items, product) {
    var best = null;
    items.forEach(function (item) {
      if (!item || item.product_id !== product.id) return;
      var pills = window.dpCart.pillCount(item.variant_title);
      if (pills && (!best || pills > best.pills)) best = { item: item, pills: pills };
    });
    return best ? best.item : null;
  }

  function itemPlanMonths(item) {
    var allocation = item.selling_plan_allocation;
    return allocation && allocation.selling_plan ? planMonths(allocation.selling_plan) : null;
  }

  function progressSubtotalCents(items) {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    try {
      if (smartCart && typeof smartCart.progressBarSubtotal === 'function') {
        var subtotal = smartCart.progressBarSubtotal();
        if (typeof subtotal === 'number' && isFinite(subtotal)) return subtotal;
      }
    } catch (error) {}
    return items.reduce(function (sum, item) { return sum + (item.final_line_price || item.line_price || 0); }, 0);
  }

  function progressTiers() {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    try {
      var bar = smartCart && typeof smartCart.getBarForLocation === 'function' ? smartCart.getBarForLocation() : null;
      return ((bar && bar.tiers) || [])
        .filter(function (tier) { return tier.unlock_condition_type === 'price' && isFinite(parseFloat(tier.minimum)); })
        .map(function (tier) { return { type: tier.type, minimum: Math.round(parseFloat(tier.minimum) * 100) }; });
    } catch (error) {
      return [];
    }
  }

  function unlockLine(subtotalBefore, subtotalAfter) {
    var crossed = progressTiers().filter(function (tier) {
      return subtotalBefore < tier.minimum && subtotalAfter >= tier.minimum;
    });
    var gift = crossed.filter(function (tier) { return tier.type === 'product'; }).sort(function (a, b) { return b.minimum - a.minimum; })[0];
    if (gift) return 'Unlocks your free gift at ' + window.dpCart.noTrailingZeros(money(gift.minimum));
    return crossed.some(function (tier) { return tier.type === 'shipping'; }) ? 'Unlocks free shipping' : null;
  }

  function cadenceLabel(months) {
    return '(every ' + months + ' month' + (months === 1 ? '' : 's') + ')';
  }

  function buildOffer(item, ladder, subtotalNow) {
    var index = -1;
    ladder.forEach(function (tier, i) { if (tier.id === item.variant_id) index = i; });
    if (index < 0) return null;
    var current = ladder[index];
    var next = ladder[index + 1] || null;
    var isSubscription = !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
    var quantity = item.quantity || 1;
    var currentPlan = (isSubscription && planForMonths(current, itemPlanMonths(item))) || naturalPlan(current);
    var currentPrice = isSubscription ? (currentPlan && currentPlan.price) : current.price;
    if (!currentPrice) return null;
    var lineTotalNow = item.price * quantity;
    var offer = { item: item, key: item.key, note: null, unlock: null, perMealNote: null, cta: null, ctaLabel: null, image: current.image, imageAlt: current.pills + ' pills' };

    if (next) {
      var nextPlan = naturalPlan(next);
      var nextPrice = isSubscription ? (nextPlan && nextPlan.price) : next.price;
      if (!nextPrice) return null;
      var saving = Math.floor((currentPrice * next.months / current.months - nextPrice) * quantity);
      offer.state = 'upgrade';
      offer.variantId = next.id;
      offer.sellingPlanId = isSubscription ? nextPlan.id : null;
      offer.image = next.image;
      offer.imageAlt = next.pills + ' pills';
      offer.title = 'Upgrade to ' + next.pills + ' pills';
      offer.cadence = isSubscription ? cadenceLabel(nextPlan.months) : '(' + next.months + '-month supply)';
      offer.perMeal = money(Math.floor(nextPrice / next.pills));
      offer.perMealCurrent = money(Math.floor(currentPrice / current.pills));
      offer.saving = saving > 0 ? 'Save ' + money(saving) + ' over ' + next.months + ' months' : null;
      offer.unlock = unlockLine(subtotalNow, subtotalNow - lineTotalNow + nextPrice * quantity);
      offer.cta = 'Upgrade';
      offer.ctaLabel = 'Upgrade to ' + next.pills + ' pills';
      return offer;
    }

    if (!isSubscription) {
      if (!currentPlan) return null;
      var discountPercent = Math.round((1 - currentPlan.price / current.price) * 100);
      var orderSaving = Math.floor((current.price - currentPlan.price) * quantity);
      offer.state = 'subscribe';
      offer.sellingPlanId = currentPlan.id;
      offer.title = 'Subscribe & Save ' + discountPercent + '%';
      offer.cadence = cadenceLabel(current.months);
      offer.perMeal = money(Math.floor(currentPlan.price / current.pills));
      offer.perMealCurrent = money(Math.floor(current.price / current.pills));
      offer.saving = orderSaving > 0 ? 'Save ' + money(orderSaving) + ' on this order' : null;
      offer.unlock = unlockLine(subtotalNow, subtotalNow - lineTotalNow + currentPlan.price * quantity);
      offer.note = 'Skip, pause, or cancel anytime — no fees';
      offer.cta = 'Subscribe';
      offer.ctaLabel = 'Subscribe & Save ' + discountPercent + '%';
      return offer;
    }

    offer.state = 'best';
    offer.title = "You're on our best value";
    offer.cadence = null;
    offer.perMeal = money(Math.floor(currentPrice / current.pills));
    offer.perMealCurrent = null;
    offer.perMealNote = '— the lowest price in the range';
    offer.saving = null;
    offer.note = 'Skip, pause, or cancel anytime — no fees';
    return offer;
  }

  function tradeupOffers(items) {
    loadTradeupProduct();
    if (!tradeupProduct || !Array.isArray(items)) return [];
    var subtotalNow = progressSubtotalCents(items);
    var signature = items.map(function (item) {
      return [item.key, item.quantity, item.price, item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : 0].join(':');
    }).join('|') + '|' + subtotalNow;
    if (signature === tradeupCache.signature) return tradeupCache.offers;
    var line = largestLadderLine(items, tradeupProduct);
    var offer = line ? buildOffer(line, buildLadder(tradeupProduct), subtotalNow) : null;
    tradeupCache = { signature: signature, offers: offer ? [offer] : [] };
    return tradeupCache.offers;
  }

  function suspendFreeGifts(on) {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (smartCart) smartCart._isProcessingUpsell = on;
  }

  function settleFreeGifts() {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (smartCart) smartCart._isProcessingUpsell = false;
    try {
      var result = smartCart && typeof smartCart.updateFreeProducts === 'function' ? smartCart.updateFreeProducts() : null;
      return result && typeof result.then === 'function' ? result : Promise.resolve();
    } catch (error) {
      return Promise.resolve();
    }
  }

  function waitForCartToSettle(callback) {
    var quietTimer = null;
    var deadline = setTimeout(finish, 6000);
    function finish() {
      clearTimeout(quietTimer);
      clearTimeout(deadline);
      document.removeEventListener('rebuy:cart.change', onChange);
      callback();
    }
    function onChange() {
      clearTimeout(quietTimer);
      quietTimer = setTimeout(finish, 800);
    }
    document.addEventListener('rebuy:cart.change', onChange);
    quietTimer = setTimeout(finish, 800);
  }

  function finishTradeupAction(button) {
    return function () {
      waitForCartToSettle(function () {
        settleFreeGifts().then(function () {
          if (!button) return;
          button.classList.remove('is-busy');
          button.disabled = false;
        });
      });
    };
  }

  function upgradeLine(offer, done) {
    var cart = window.Rebuy && window.Rebuy.Cart;
    if (!cart) return done();
    var item = offer.item;
    var payload = { id: offer.variantId, quantity: item.quantity, properties: Object.assign({}, item.properties) };
    if (offer.sellingPlanId) payload.selling_plan = offer.sellingPlanId;
    cart.addItem(payload, {
      success: function () { cart.removeItem(item, { success: done, error: done }); },
      error: done
    });
  }

  function subscribeLine(offer, done) {
    var cart = window.Rebuy && window.Rebuy.Cart;
    if (!cart) return done();
    var item = offer.item;
    cart.changeItem({
      id: item.key,
      quantity: item.quantity,
      selling_plan: offer.sellingPlanId,
      properties: Object.assign({}, item.properties, { _source: 'Rebuy', _attribution: 'Rebuy Switch to Subscription' })
    }, { success: done, error: done });
  }

  window.dpCart = {
    pillCount: safe(function (variantTitle) {
      if (typeof variantTitle !== 'string') return null;
      var match = variantTitle.match(/(\d+)\s*(pills?|ct|tablets?)/i);
      return match ? parseInt(match[1], 10) : null;
    }, null),

    variantLabel: safe(function (variantTitle) {
      if (typeof variantTitle !== 'string' || variantTitle === '' || variantTitle === 'Default Title') return null;
      if (/(\d+)\s*(pills?|ct|tablets?)/i.test(variantTitle)) {
        return 'Quantity: ' + variantTitle.replace(/(\d+)\s*ct/i, '$1 pills');
      }
      return variantTitle;
    }, null),

    itemVariantLabel: safe(function (item) {
      if (!item) return null;
      var title = item.variant_title;
      if (typeof title === 'string' && /(\d+)\s*(pills?|ct|tablets?)/i.test(title)) {
        return 'Quantity: ' + title.replace(/(\d+)\s*ct/i, '$1 pills');
      }
      var options = item.options_with_values;
      if (Array.isArray(options)) {
        var parts = options
          .filter(function (option) {
            return option && option.name !== 'Title' && option.value && option.value !== 'Default Title';
          })
          .map(function (option) { return option.name + ': ' + option.value; });
        if (parts.length) return parts.join(', ');
        if (options.length) return null;
      }
      if (typeof title === 'string' && title !== '' && title !== 'Default Title') return title;
      return null;
    }, null),

    perMealHTML: safe(function (priceCents, variantTitle) {
      var cents = toCents(priceCents);
      var pills = window.dpCart.pillCount(variantTitle);
      if (!cents || !pills) return null;
      var perPillCents = Math.floor(cents / pills);
      return '<b>$' + (perPillCents / 100).toFixed(2) + '</b> / dairy meal';
    }, null),

    optionCaption: safe(function (product, variant) {
      if (!variant || !variant.title || variant.title === 'Default Title') return null;
      var optionName = product && product.options && product.options[0] && (product.options[0].name || product.options[0]);
      if (typeof optionName === 'string' && optionName !== 'Title') {
        return optionName + ': ' + variant.title;
      }
      return variant.title;
    }, null),

    remapProgress: safe(function (percent, tierCount) {
      var p = parseFloat(percent);
      var n = parseInt(tierCount, 10);
      if (!isFinite(p) || !n || n < 1) return percent;
      var seg = 100 / n;
      var prevX = 0;
      var prevY = 0;
      for (var k = 0; k < n; k++) {
        var centerX = seg * (k + 0.5);
        var targetY = seg * (k + 1);
        if (p <= centerX) {
          return (prevY + ((p - prevX) / (centerX - prevX)) * (targetY - prevY)).toFixed(2) + '%';
        }
        prevX = centerX;
        prevY = targetY;
      }
      return '100%';
    }, null),

    highlightMoney: safe(function (text) {
      if (typeof text !== 'string') return text;
      if (/\$\d/.test(text)) {
        return text.replace(/(\$\d[\d,]*(?:\.\d{2})?)/, '<span class="dp-cart__money-accent">$1</span>');
      }
      return text.replace(/unlocked (.+)$/, 'unlocked <span class="dp-cart__money-accent">$1</span>');
    }, ''),

    // window.dpReviews (snippets/dp-reviews-map.liquid) lists only the products whose
    // page shows reviews.
    ratingHTML: safe(function (handle) {
      var mapped = window.dpReviews && handle ? window.dpReviews[handle] : null;
      if (!mapped) return null;
      var rating = parseFloat(mapped.rating);
      var count = parseInt(mapped.count, 10);
      if (!rating || !count) return null;
      var percent = Math.round((Math.min(rating, 5) / 5) * 1000) / 10;
      var value = (Math.round(rating * 10) / 10).toFixed(1);
      var countText = count.toLocaleString('en-US');
      return '<span class="dp-cart__rating" role="img" aria-label="Rated ' + value + ' out of 5 from ' + countText + ' reviews">' +
        '<span class="dp-cart__rating-stars" aria-hidden="true"><span class="dp-cart__rating-fill" style="width:' + percent + '%"></span></span>' +
        '<span class="dp-cart__rating-value" aria-hidden="true">' + value + '</span>' +
        '<span class="dp-cart__rating-count" aria-hidden="true">(' + countText + ')</span></span>';
    }, null),

    noTrailingZeros: safe(function (money) {
      if (typeof money !== 'string') return money;
      return money.replace(/\.00(?=\D*$)/, '');
    }, ''),

    itemCountLabel: safe(function () {
      var cart = readCart();
      if (!cart) return 'Subtotal';
      var count = cart.item_count;
      return 'Subtotal (' + count + (count === 1 ? ' item' : ' items') + ')';
    }, 'Subtotal'),

    waitForSmartCart: safe(function (fallbackUrl) {
      var deadline = Date.now() + 12000;
      (function poll() {
        if (window.Rebuy && window.Rebuy.SmartCart && document.getElementById('rebuy-cart')) {
          try { window.Rebuy.SmartCart.show(); return; } catch (error) {}
        }
        if (Date.now() > deadline) {
          if (fallbackUrl) window.location = fallbackUrl;
          return;
        }
        setTimeout(poll, 150);
      })();
    }, undefined),

    shippingLabel: safe(function () {
      var cart = readCart();
      if (cart && typeof cart.items_subtotal_price === 'number' && cart.items_subtotal_price >= FREE_SHIP_CENTS) {
        return 'Free';
      }
      if (cart && typeof cart.total_price === 'number' && cart.total_price >= FREE_SHIP_CENTS) {
        return 'Free';
      }
      return 'Calculated at checkout';
    }, 'Calculated at checkout'),

    hasTradeup: safe(function (items) {
      return tradeupOffers(items).length > 0;
    }, false),

    tradeupOffers: safe(function (items) {
      return tradeupOffers(items);
    }, []),

    tradeupAction: safe(function (offer, event) {
      var button = event && event.currentTarget;
      if (button) {
        button.classList.add('is-busy');
        button.disabled = true;
      }
      var done = finishTradeupAction(button);
      suspendFreeGifts(true);
      if (offer.state === 'upgrade') upgradeLine(offer, done);
      else if (offer.state === 'subscribe') subscribeLine(offer, done);
      else done();
    }, undefined)
  };

  function renderBadge(count) {
    document.querySelectorAll('#cart-icon-bubble, .header__icon--cart').forEach(function (anchor) {
      var bubble = anchor.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          anchor.appendChild(bubble);
        }
        var visible = count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '';
        bubble.innerHTML = visible + '<span class="visually-hidden">' + count + ' items</span>';
      } else if (bubble) {
        bubble.remove();
      }
    });
  }

  var badgeSyncTimer = null;

  function syncHeaderBadge(event) {
    try {
      var cart = (event && event.detail && event.detail.cart) || readCart();
      if (cart && typeof cart.item_count === 'number') {
        renderBadge(cart.item_count);
        return;
      }
      clearTimeout(badgeSyncTimer);
      badgeSyncTimer = setTimeout(function () {
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
          .then(function (response) { return response.json(); })
          .then(function (data) { renderBadge(data.item_count); })
          .catch(function () {});
      }, 300);
    } catch (error) {}
  }

  ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.add'].forEach(function (type) {
    document.addEventListener(type, syncHeaderBadge);
  });

  document.addEventListener('rebuy:cart.ready', loadTradeupProduct);

  try {
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      var viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta && !/maximum-scale/.test(viewportMeta.content)) {
        viewportMeta.content += ', maximum-scale=1';
      }
    }
  } catch (error) {}

  document.addEventListener('click', function (event) {
    try {
      var link = event.target.closest('#cart-icon-bubble, a.header__icon--cart');
      if (!link) return;
      event.preventDefault();
      window.dpCart.waitForSmartCart(link.href);
    } catch (error) {}
  });

  document.addEventListener('click', function (event) {
    try {
      var btn = event.target.closest('.dp-cart__rec-add');
      if (btn && !btn.disabled) btn.classList.add('is-adding');
    } catch (error) {}
  });

  ['rebuy:cart.add', 'rebuy:cart.change'].forEach(function (type) {
    document.addEventListener(type, function () {
      try {
        document.querySelectorAll('.dp-cart__rec-add.is-adding').forEach(function (btn) {
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        });
      } catch (error) {}
    });
  });
})();
